import script from "./ModificaRilevazione.vue?vue&type=script&setup=true&lang=js"
export * from "./ModificaRilevazione.vue?vue&type=script&setup=true&lang=js"

import "./ModificaRilevazione.vue?vue&type=style&index=0&id=11a718dd&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a718dd"]])

export default __exports__